<template>
  <IconMaterial title="show_chart" size="16" />
</template>

<script>
  import IconMaterial from '@/uikitBase/icons/IconMaterial';

  export default {
    name: 'IconInjection',

    components: {
      IconMaterial,
    },
  };
</script>
